import { render, staticRenderFns } from "./TelaSucesso.vue?vue&type=template&id=413277a7&"
import script from "./TelaSucesso.vue?vue&type=script&lang=js&"
export * from "./TelaSucesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports